import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import FeePopup from "../../components/popups/feePopup/FeePopup";
import { feeData, getStudentFee } from "../../reducers/feeSlice";
import "./FeePageStyle.css";
import moment from "moment";
import FeePaymentType from "../../components/popups/feePopup/FeePaymentType";
import PageLoader from "../../components/globalComponents/PageLoader/PageLoader";

const Fee = () => {
  const dispatch = useDispatch();
  const { isFetching, feeDetails, isBankTransferSuccess } =
    useSelector(feeData);

  //state
  const [isLoading, setIsLoading] = useState(false);
  const [payNow, setPayNow] = useState(false);
  const [studentFeeList, setStudentFeeList] = useState([]);
  const [paymentLink, setPaymentLink] = useState("");
  const [feeDueId, setFeeDueId] = useState("");

  useEffect(() => {
    dispatch(getStudentFee());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsLoading(isFetching);
    // eslint-disable-next-line
  }, [isFetching]);

  useEffect(() => {
    setStudentFeeList(feeDetails && feeDetails.FeeDues);
  }, [feeDetails]);

  const convertDueDate = (date) => {
    var dueDate = moment(date).format("ll");
    return dueDate;
  };

  const handleFeeTypePopup = () => {
    setPayNow(false);
    setPaymentLink("");
    // setFeeDueId("");
  };

  const onClickViewDetails = (link) => {
    window.open(link);
  };

  useEffect(() => {
    if (isBankTransferSuccess) {
      handleFeeTypePopup();
      setFeeDueId("");
      dispatch(getStudentFee());
    }
    // eslint-disable-next-line
  }, [isBankTransferSuccess]);

  console.log("fee due id", feeDueId);

  return (
    <>
      {isLoading && <PageLoader />}
      <FeePaymentType
        paymentLink={paymentLink}
        isShow={payNow}
        setClose={handleFeeTypePopup}
        feeDueId={feeDueId}
      />

      <div class="pageHeaderType3">
        <div class="backBtn">
          <img src="../assets/icons/back-btn.svg" alt="" />
          Back to Page
        </div>

        <div class="pageTogglers">
          <div class="pageToggler active">
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.97325 1.875H14.0268C14.7041 1.87499 15.2505 1.87499 15.6929 1.91114C16.1484 1.94835 16.5485 2.02699 16.9187 2.2156C17.5067 2.51521 17.9848 2.99327 18.2844 3.58128C18.473 3.95146 18.5516 4.35158 18.5889 4.80711C18.625 5.24953 18.625 5.79587 18.625 6.47323V11.0268C18.625 11.7041 18.625 12.2505 18.5889 12.6929C18.5516 13.1484 18.473 13.5485 18.2844 13.9187C17.9848 14.5067 17.5067 14.9848 16.9187 15.2844C16.5485 15.473 16.1484 15.5516 15.6929 15.5889C15.2505 15.625 14.7041 15.625 14.0268 15.625H11.9031C11.358 15.625 11.1722 15.6279 11 15.6633C10.8345 15.6972 10.6744 15.7534 10.5239 15.8303C10.3674 15.9102 10.2204 16.0241 9.79478 16.3646L7.78762 17.9703C7.63101 18.0956 7.48183 18.215 7.35283 18.3003C7.22821 18.3827 7.01748 18.5078 6.75112 18.5081C6.43389 18.5084 6.1338 18.3642 5.93589 18.1163C5.76973 17.9081 5.73579 17.6654 5.72227 17.5166C5.70829 17.3626 5.70831 17.1715 5.70833 16.971L5.70833 15.6228C5.29807 15.6168 4.97756 15.5953 4.69119 15.5185C3.61278 15.2296 2.77044 14.3872 2.48148 13.3088C2.3746 12.9099 2.37475 12.4448 2.37498 11.7632C2.37499 11.7315 2.375 11.6993 2.375 11.6667L2.375 6.47325C2.37499 5.79588 2.37499 5.24953 2.41114 4.80711C2.44835 4.35158 2.52699 3.95146 2.7156 3.58128C3.01521 2.99327 3.49327 2.51521 4.08128 2.2156C4.45146 2.02699 4.85158 1.94835 5.30711 1.91114C5.74953 1.87499 6.29588 1.87499 6.97325 1.875ZM5.4089 3.15699C5.03067 3.18789 4.81336 3.2455 4.64877 3.32936C4.29596 3.50913 4.00912 3.79596 3.82936 4.14877C3.7455 4.31337 3.68789 4.53067 3.65698 4.9089C3.62549 5.29443 3.625 5.78962 3.625 6.5V11.6667C3.625 12.4819 3.63037 12.7669 3.68889 12.9853C3.86226 13.6323 4.36767 14.1377 5.01471 14.3111C5.23312 14.3696 5.51812 14.375 6.33333 14.375C6.67851 14.375 6.95833 14.6548 6.95833 15V16.9462C6.95833 16.9768 6.95834 17.0056 6.95838 17.0328C6.97966 17.0159 7.00217 16.9979 7.02603 16.9788L9.01391 15.3885C9.0298 15.3758 9.04548 15.3632 9.06095 15.3508C9.42181 15.062 9.6717 14.862 9.95523 14.7171C10.206 14.589 10.4729 14.4954 10.7487 14.4388C11.0606 14.3748 11.3807 14.3749 11.8429 14.375C11.8627 14.375 11.8828 14.375 11.9031 14.375H14C14.7104 14.375 15.2056 14.3745 15.5911 14.343C15.9693 14.3121 16.1866 14.2545 16.3512 14.1706C16.704 13.9909 16.9909 13.704 17.1706 13.3512C17.2545 13.1866 17.3121 12.9693 17.343 12.5911C17.3745 12.2056 17.375 11.7104 17.375 11V6.5C17.375 5.78962 17.3745 5.29443 17.343 4.9089C17.3121 4.53067 17.2545 4.31337 17.1706 4.14877C16.9909 3.79596 16.704 3.50913 16.3512 3.32936C16.1866 3.2455 15.9693 3.18789 15.5911 3.15699C15.2056 3.12549 14.7104 3.125 14 3.125H7C6.28962 3.125 5.79443 3.12549 5.4089 3.15699ZM10.8119 6.05964C10.5212 6.00979 10.2223 6.06441 9.96812 6.21381C9.7139 6.36322 9.52077 6.59777 9.42292 6.87593C9.30837 7.20155 8.95155 7.37266 8.62593 7.25811C8.30031 7.14357 8.1292 6.78675 8.24375 6.46113C8.43956 5.9045 8.82605 5.43512 9.33477 5.13615C9.84349 4.83717 10.4416 4.72788 11.0232 4.82764C11.6048 4.92739 12.1323 5.22975 12.5123 5.68117C12.8921 6.13245 13.1001 6.70357 13.0994 7.29345C13.0992 8.24956 12.3903 8.88091 11.8843 9.2183C11.6122 9.39969 11.3445 9.53307 11.1474 9.6207C11.0479 9.66491 10.9641 9.69845 10.9038 9.72145C10.8735 9.73296 10.849 9.74189 10.8312 9.74823L10.8095 9.75583L10.8026 9.75819L10.8001 9.75901L10.7992 9.75933C10.799 9.75939 10.7984 9.75959 10.6008 9.16667L10.7992 9.75933C10.4717 9.86849 10.117 9.69177 10.0078 9.36431C9.89883 9.03728 10.0752 8.68384 10.4018 8.57418C10.4021 8.57407 10.4025 8.57396 10.4028 8.57385L10.4124 8.57046C10.422 8.56705 10.4378 8.56134 10.4588 8.55334C10.5009 8.5373 10.5635 8.51229 10.6397 8.47843C10.7938 8.40993 10.9946 8.3091 11.1909 8.17823C11.6215 7.89113 11.8494 7.58581 11.8494 7.29306L11.8494 7.29213C11.8498 6.99726 11.7459 6.71175 11.556 6.48617C11.3661 6.26059 11.1025 6.10949 10.8119 6.05964ZM9.99992 11.6667C9.99992 11.3215 10.2797 11.0417 10.6249 11.0417H10.6333C10.9784 11.0417 11.2583 11.3215 11.2583 11.6667C11.2583 12.0118 10.9784 12.2917 10.6333 12.2917H10.6249C10.2797 12.2917 9.99992 12.0118 9.99992 11.6667Z"
                fill="#0061BF"
              />
            </svg>
            Payment Details
          </div>
        </div>

        {/* <button class="primaryBtn hidden-componet">Save as Draft</button> */}
      </div>

      {/* <div class="filterBar">
        <div class="searchBox">
          <img src="../assets/icons/search-sm.svg" alt="" />
          <input type="text" class="searchInput" placeholder="Search ..." />
        </div>
        <button class="fiterBtn">
          <img src="../assets/icons/filter-lines.svg" alt="" /> Filters
        </button>
      </div> */}

      <div class="feedbackTableContainer">
        <table class="feedbackTable" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Fee Category</th>
              <th>Fee Amount</th>
              <th>Due On</th>
              <th>Status</th>
              <th>Payment Details</th>
            </tr>
          </thead>
          <tbody>
            {studentFeeList?.map((item, index) => {
              const {
                feeDue,
                dueOn,
                // paymentStatus,
                // studentId,
                paymentLink,
                id,
                isPaid,
                // isBankLoan,
                // isBankTransfer,
                // isMuLoan,
                // cashFreeStatus,
                // isOnlinePayment,
                Fee,
                paymentRecieptLink,
              } = item;
              return (
                <tr key={id}>
                  <td>{Fee?.FeeMaster?.feeName}</td>
                  <td>₹ {parseFloat(feeDue).toFixed(2)}</td>
                  <td>{convertDueDate(dueOn)}</td>
                  {/* <td>1/20/22</td> */}
                  <td>
                    {isPaid ? (
                      <p>Paid</p>
                    ) : (
                      <div class="primaryTag">Pending</div>
                    )}
                  </td>
                  <td>
                    {isPaid ? (
                      <button
                        class="successSecondaryBtnSmall"
                        onClick={() => onClickViewDetails(paymentRecieptLink)}
                      >
                        View Details
                      </button>
                    ) : (
                      <button
                        class="successSecondaryBtnSmall"
                        onClick={() => {
                          setPaymentLink(paymentLink);
                          setPayNow(true);
                          setFeeDueId(id);
                        }}
                      >
                        Pay Now
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}

            {/* <tr>
              <td>Product Management | Session- 1</td>
              <td>Applied Finance</td>
              <td>Cohort - 1</td>
              <td>1/20/22</td>
              <td>
                <div class="primaryTag">Pending</div>
              </td>
              <td>
                <button class="successSecondaryBtnSmall verified">
                  Payment Verified
                </button>
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Fee;
